import React,{ useState, useEffect } from 'react';
import {AiOutlineUserAdd} from 'react-icons/ai';
import EditIconButton from "../../components/IconButtons/EditIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../../contexts/ContextProvider';
import { useTicketsMutations } from '../../hooks';
import {getTickets} from "../../services/Tikets";
import {formatDate} from '../../formatters/date';
import DataTable from 'react-data-table-component';
import { NuevoTicketsLF } from '../../components';


const NavButton = ({ title, customFunc, icon, color, texto }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ backgroundColor: color}}
      className="relative text-xl  text-white rounded-lg p-3 hover:bg-light-gray"
    >
      <div className="flex flex-row justify-between items-center">
        <div>{icon}</div>
        <div><p className="text-xs ">{texto}</p></div>
      </div>
    
    </button>

  </TooltipComponent>
);

const Tickets = () => {
  const { currentColor, handleClick, isClicked } = useStateContext();
  const {removeTicket} = useTicketsMutations();
  const [sucursalesData, setSucursalesData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");


  useEffect(()=>{
    const fetchData = async () => {
      const misSucursales = await getTickets();
      setSucursalesData(misSucursales);
    };
    fetchData();
  },[]);

  const handleEdit = (sucursalData) => {
    setLaSucursal(sucursalData);
    handleClick('nuevoTicket');
  };

  const handleEliminar = async (row) => {
    setSucursalesData((prevData) => prevData.filter((item) => item._id !== row._id));
    await removeTicket.mutateAsync(row._id);
    setSucursalesData((prevData) =>(prevData));
  };

  const handleRefreshDataTable = (opcion) => {
    if (opcion==="REFRESH"){
      const fetchData = async () => {
        const losFiados = await getTickets();
        setSucursalesData(losFiados);
      };
      fetchData();
    }

  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: 'white',
      },
    },
    headRow: {
      style: {
        backgroundColor: 'white',
        fontSize: 12,
        borderRadius: 8,
        fontWeight: '400',
        color: '#AEB2D7',
        borderWidth: 0,
        textAlign: 'center',
        headerStyles:{
          backgroundColor: '#F2F5FE',
          fontWeight: 'bold',
          color: '#2F336A',
        },
      },
    },
    rows: {
      style: {
        minHeight: '50px',
        margin: '4px 0px',
        backgroundColor: 'white',
        borderRadius: 8,
        fontSize: 10,
        rowStyles:{
          borderBottom: 1,
        }
      },
    },
  };

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <EditIconButton onClick={() => handleEdit(row)} /> )
    },
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: 'Fecha Creación',
      width: '180px',
      selector: row => formatDate(row.fechaCreacion),
      sortable: true
    },
    {
      name: 'N° Ticket',
      width: '130px',
      selector: row => row.numTicket,
      sortable: true
    },
    {
      name: 'Requerimiento',
      width: '280px',
      selector: row => row.requerimiento,
      sortable: true
    },
    {
      name: 'Observación',
      width: '200px',
      selector: row => row.observacion,
      sortable: true
    },
 
    {
      name: 'Asigndo a ',
      width: '180px',
      selector: row => row.nombreAsignado,
      sortable: true
    },
    {
      name: 'Creado por',
      width: '180px',
      selector: row => row.nombreCreador,
      sortable: true
    },
    {
      name: 'Estado',
      width: '100px',
      selector: row => row.estado,
      sortable: true
    }
  ];

  return (
    <div className="m-2 md:m-10 mt-16 p-2 md:p-10 bg-white rounded-3xl">
        <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">

        <div  className="flex flex-col md:flex-row relative w-2/3">

          </div>
            <div className="flex flex-col justify-end">
              <NavButton title="Agregar Ticket" customFunc={() => { setLaSucursal(''); handleClick('nuevoTicket')} } color={currentColor} icon={<AiOutlineUserAdd />} texto={'Nuevo Ticket'} />
            </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">   
          <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
            <div className="flex flex-col">
              <DataTable
                columns={columns}
                data={sucursalesData}
                highlightOnHover
                pagination={true}
                striped
                className="border border-gray-300 rounded-lg shadow-sm"
                noHeader={true}
                selectableRowsHighlight
                customStyles={customStyles}
                noDataComponent={'No hay Tickets creados'}
              />
            </div>
          </div>
        </div>
      {isClicked.nuevoTicket && (<NuevoTicketsLF vecinoData={laSucursal} onChangeVecino={handleRefreshDataTable}/>)}
    </div>
  );
};

export default Tickets;